import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    save: {},
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {page, filterData} = {}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};
        if (page) {
            if (page.current) params.page = page.current;
            if (page.pageSize) params.page_limit = page.pageSize;
        }
        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['module_assignment'], {
            params: params
        })

        const {data} = res.data
        commit('updateTableData', data)

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    async show({commit}, {id}) {
        commit('setLoading', true)
        commit('updateSaveData', {})

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['module_assignment'] + '/' + id)
            const {data} = res.data

            commit('updateSaveData', data)
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async add({commit}, {formData}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.post(this._vm.endpoints['module_assignment'], formData)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async update({commit}, {id, formData}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.put(this._vm.endpoints['module_assignment'] + '/' + id, formData)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    //  delete record
    async delete({commit, dispatch}, {id}) {
        let successDeleted = [];

        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoints['module_assignment'] + '/' + id[i]);
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'));
                    successDeleted.push(id[i]);
                } else {
                    this._vm.$message.error(data.message)
                }
            }

            dispatch('refresh')

            return successDeleted;
        }
    },

    // refresh records
    refresh({dispatch}) {
        dispatch('get');
    }
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updateSaveData(state, data) {
        state.save.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}